import { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import moment from 'moment';
import { alertError } from 'services/alerts';

// Actions
import { rejectUnpApById, addUnpAp } from '../../../../reducer/actions';

// Components
import CustomModal from 'components/CustomModal';

import L_CreateNewAppointment from './components/L_CreateNewAppointment';
import R_AppointmentsList from './components/R_AppointmentsList';
import TopCaption from './components/TopCaption';

// Styles
import * as modalStyles from 'components/CustomModal/styles';
import { ColumnsWrapper } from './styles';

const ApplyModal = ({
  addUnpAp,
  unplannedAppointmentData,
  isOpen,
  closeModal,
  i18n,
  isResolved,
  practitionersList,
  replaceAp,
  campusesList,
  preferCampusId
}) => {
  const [newAppointment, setNewAppointment] = useState(null);
  const [selectExistAppointment, setSelectExistAppointment] = useState(null);
  const [disableCreateNewAppointment, setDisableCreateNewAppointment] = useState(null);

  useEffect(
    () => {
      if (isOpen) {
        setNewAppointment(null);
        setSelectExistAppointment(null);
        setDisableCreateNewAppointment(null);
      }
    },
    [isOpen]
  );

  const onConfirm = () => {
    try {
      let clarifyingData = {};
      if (disableCreateNewAppointment) {
        // we replace appointment
        clarifyingData = {
          campusId: selectExistAppointment.campus.id,
          dateTime: selectExistAppointment.dateTime,
          practitionerId: selectExistAppointment.practitioner.id,
          note: selectExistAppointment.note
        };
        replaceAp(unplannedAppointmentData.id, clarifyingData, selectExistAppointment.id).then(
          () => {
            closeModal();
          }
        );
      } else {
        // create new appointment
        clarifyingData = {
          campusId: newAppointment.campus.id,
          dateTime: moment.utc(newAppointment.time).format(),
          practitionerId: newAppointment.practitionerId,
          note: newAppointment.noteMessage
        };
        if (addUnpAp && closeModal) {
          addUnpAp(unplannedAppointmentData.id, clarifyingData).then(() => {
            closeModal();
          });
        }
      }
    } catch (e) {
      console.log('Replace appointment error ', e);
      alertError();
    }
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={closeModal}
      style={{ content: { maxWidth: '55em', padding: 0 } }}
    >
      <modalStyles.CommonModalWrapper>
        {/* ──── Header ───────────────────────────────────────────────────────────────────── */}
        <modalStyles.ModalBlockSection className="header-wrapper">
          <modalStyles.ModalCloseIcon className="close-icon" onClick={closeModal} />
          <modalStyles.ModalTitle>{i18n.t('add_unplanned_appointment')}</modalStyles.ModalTitle>
        </modalStyles.ModalBlockSection>

        {/* ──── Caption ───────────────────────────────────────────────────────────────────── */}

        <modalStyles.ModalBlockSection>
          <TopCaption
            appointmentData={unplannedAppointmentData}
            practitionersList={practitionersList}
          />
        </modalStyles.ModalBlockSection>

        {/* ──── Content ───────────────────────────────────────────────────────────────────── */}

        <ColumnsWrapper>
          <L_CreateNewAppointment
            appointmentData={unplannedAppointmentData}
            campusesList={campusesList}
            disableSection={disableCreateNewAppointment}
            practitionersList={practitionersList}
            preferCampusId={preferCampusId}
            onChangeNewAppointment={setNewAppointment}
          />

          <R_AppointmentsList
            prefPractitionerId={unplannedAppointmentData && unplannedAppointmentData.practitionerId}
            practitionersList={practitionersList}
            onSelectExistAppointment={exApp => {
              setSelectExistAppointment(exApp);
              setDisableCreateNewAppointment(!!exApp);
            }}
          />
        </ColumnsWrapper>

        {/* ──── Footer ────────────────────────────────────────────────────────────────────── */}

        <modalStyles.ModalFooter className="footer" borderTop={true}>
          <modalStyles.ModalCancel onClick={closeModal}>{i18n.t('cancel')}</modalStyles.ModalCancel>

          <modalStyles.ModalFooterBtn
            disabled={isResolved}
            style={{ minWidth: '250px' }}
            onClick={onConfirm}
          >
            {i18n.t(disableCreateNewAppointment ? 'update_appointment' : 'add_new_appointment')}
          </modalStyles.ModalFooterBtn>
          {isResolved ? (
            <span className="resolve-message">{i18n.t('event_was_resolved')}</span>
          ) : null}
        </modalStyles.ModalFooter>
      </modalStyles.CommonModalWrapper>
    </CustomModal>
  );
};

const mapStateToProps = state => {
  const { practitioner } = state;
  return {
    isOpenDrawer: state.ui.isOpenDrawer,
    unplannedList: practitioner.appointments.unplannedList,
    practitionersList: practitioner.common.practitionersList,
    campusesList: practitioner.common.campusesList,
    preferCampusId: practitioner.common.commonFilters.campusId
  };
};

export default translate()(
  connect(
    mapStateToProps,
    { addUnpAp, rejectUnpApById }
  )(ApplyModal)
);
